import {Alert, AlertDescription, AlertIcon, AlertTitle} from '@chakra-ui/react'

type AlertProps = {
  title: string
  description: string
}
export const AlertInfo = ({title, description}: AlertProps) => {
  return (
    <Alert
      mt={5}
      status="info"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="200px"
    >
      <AlertIcon boxSize="40px" mr={0} />
      <AlertTitle mt={4} mb={1} fontSize="lg">
        {title}
      </AlertTitle>
      <AlertDescription maxWidth="sm">{description}</AlertDescription>
    </Alert>
  )
}
